// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timePickerComponent {
  display: flex;
  justify-content: space-between;
  height: 50px;
  margin-top: 0.313rem;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  padding: 1rem 1.75rem;
}
.timePickerComponent .leftContainerItems {
  display: flex;
  flex-direction: row;
}
.timePickerComponent .leftContainerItems .iconLeft {
  padding: 0 0.938rem 0px 1.25rem;
  position: relative;
  bottom: 3px;
}
.timePickerComponent .leftContainerItems .inputLeft {
  border: none;
  padding-left: 0.313rem;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 24px;
  color: #333333;
}
.timePickerComponent .dashIcon {
  position: relative;
  bottom: 0.313rem;
}
.timePickerComponent .rightContainerItems {
  display: flex;
  flex-direction: row;
}
.timePickerComponent .rightContainerItems .iconRight {
  padding: 0 0.938rem 0px 1.25rem;
  position: relative;
  bottom: 3px;
}
.timePickerComponent .rightContainerItems .inputRight {
  border: none;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 24px;
  color: #333333;
}`, "",{"version":3,"sources":["webpack://./src/components/timePicker/timePicker.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;AACR;AAAQ;EACI,+BAAA;EACA,kBAAA;EACA,WAAA;AAEZ;AAAQ;EACI,YAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAEZ;AAEI;EACI,kBAAA;EACA,gBAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;AADR;AAEQ;EACI,+BAAA;EACA,kBAAA;EACA,WAAA;AAAZ;AAGQ;EACI,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ","sourcesContent":[".timePickerComponent {\n    display: flex;\n    justify-content: space-between; \n    height: 50px;\n    margin-top: 0.313rem;\n    background: #ffffff;\n    border: 1px solid #e9e9e9;\n    border-radius: 8px;\n    padding: 1rem 1.75rem;\n\n    .leftContainerItems {\n        display: flex;\n        flex-direction: row; \n        .iconLeft {\n            padding: 0 0.938rem 0px 1.25rem;\n            position: relative;\n            bottom: 3px;\n        }\n        .inputLeft {\n            border: none;\n            padding-left: 0.313rem; \n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 1rem;\n            line-height: 24px;\n            color: #333333;\n        }\n    }\n \n    .dashIcon{\n        position: relative;\n        bottom: 0.313rem;\n        \n    }\n    .rightContainerItems {\n        display: flex;\n        flex-direction: row; \n        .iconRight {\n            padding: 0 0.938rem 0px 1.25rem;\n            position: relative;\n            bottom: 3px;\n        }\n\n        .inputRight {\n            border: none;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 1rem;\n            line-height: 24px;\n            color: #333333;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
